/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import "./EmpPendingDsrAlert.css";

const REFRESH_INTERVAL = 5 * 60 * 1000;

const EmpPendingDsrAlert = () => {
  const [dsrData, setDsrData] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const navigate = useNavigate();

  const fetchPendingDsr = async (showAlert = false) => {
    try {
      const LoginToken = GetToken();
      if (!LoginToken) return;

      const res = await axios({
        method: "GET",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Projects/CheckPendingDsr`,
      });

      const data = res?.data?.data || res?.data || null;
      setLastUpdated(new Date());

      // handle different possible API response values
      const isPending =
        data?.isPending === true ||
        data?.isPending === "true" ||
        data?.pending === true ||
        data?.status === "Pending";

      if (isPending) {
        setDsrData({
          pendingDate: data?.pendingDate || data?.PendingDate || "-",
          dayName: data?.dayName || data?.DayName || "-",
          message:
            data?.message ||
            data?.Message ||
            "Your Daily Status Report is pending.",
        });

        if (showAlert) {
          setShowToast(true);
        }
      } else {
        setDsrData(null);
        setShowToast(false);
        setShowModal(false);
      }
    } catch (error) {
      console.log("CheckPendingDsr error:", error?.response || error);

      if (error?.response?.status === 401) {
        toast.error("Your session has expired");
        RemoveUserSession();
        navigate("/", { replace: true });
      }
    }
  };

  useEffect(() => {
    fetchPendingDsr(true);
    const interval = setInterval(() => fetchPendingDsr(true), REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, []);

//   useEffect(() => {
//     if (!showToast) return;
//     const timer = setTimeout(() => setShowToast(false), 8000);
//     return () => clearTimeout(timer);
//   }, [showToast]);

  const handleToastClick = () => {
    setShowToast(false);
    setShowModal(true);
  };

  if (!dsrData) return null;

  return createPortal(
    <>
      {showToast && (
        <div className="emp-dsr-toast" onClick={handleToastClick}>
          <div className="emp-dsr-toast-row1">
            <span className="emp-dsr-toast-title">
              <span className="emp-dsr-red-dot" />
              DSR Pending
            </span>
            <span className="emp-dsr-toast-time">just now</span>
            <button
              type="button"
              className="emp-dsr-toast-close"
              onClick={(e) => {
                e.stopPropagation();
                setShowToast(false);
              }}
            >
              ×
            </button>
          </div>

          <p className="emp-dsr-toast-sub">
            You haven't filled your DSR since{" "}
            <strong>{dsrData?.pendingDate}</strong> ({dsrData?.dayName})
          </p>

          <p className="emp-dsr-toast-cta">Click to view details →</p>
        </div>
      )}

      {showModal && (
        <div className="emp-dsr-overlay" onClick={() => setShowModal(false)}>
          <div
            className="emp-dsr-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="emp-dsr-modal-head">
              <div className="emp-dsr-modal-head-left">
                <div className="emp-dsr-icon-circle">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#A32D2D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </div>

                <div>
                  <h2>DSR Not Filled</h2>
                  <p>Your Daily Status Report is pending</p>
                </div>
              </div>

              <button
                type="button"
                className="emp-dsr-modal-close"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>

            <div className="emp-dsr-modal-body">
              <div className="emp-dsr-alert-box">
                <p>{dsrData?.message}</p>
              </div>

              <div className="emp-dsr-info-grid">
                <div className="emp-dsr-info-card">
                  <span className="emp-dsr-info-label">Pending Since</span>
                  <span className="emp-dsr-info-value">
                    {dsrData?.pendingDate || "-"}
                  </span>
                </div>

                <div className="emp-dsr-info-card">
                  <span className="emp-dsr-info-label">Day</span>
                  <span className="emp-dsr-info-value">
                    {dsrData?.dayName || "-"}
                  </span>
                </div>
              </div>

              <button
  type="button"
  className="emp-dsr-fill-btn"
  onClick={() => {
    setShowModal(false);
    navigate("/Emp/DailyStatusReport");
  }}
>
  Fill DSR Now
</button>
            </div>

            <div className="emp-dsr-modal-foot">
              {/* <span>Auto-refreshes every 5 min</span> */}
              <span>
                Last updated:{" "}
                {lastUpdated ? moment(lastUpdated).format("hh:mm A") : "-"}
              </span>
            </div>
          </div>
        </div>
      )}
    </>,
    document.body
  );
};

export default EmpPendingDsrAlert;